/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type Header_viewer = {
    readonly user?: {
        readonly isVip: boolean | null;
        readonly isVerifiedTrade: boolean | null;
        readonly profile: {
            readonly currency: Currency | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"userTracking_user" | "TopBar_user">;
    } | null;
    readonly regionalInfo?: ReadonlyArray<{
        readonly incomeLevel: {
            readonly incomeBracket: string | null;
            readonly incomePercentile: string | null;
        } | null;
        readonly currency: string | null;
    } | null> | null;
    readonly relayIsClient: "Viewer";
    readonly " $fragmentRefs": FragmentRefs<"userTracking_viewer" | "TopBar_viewer" | "BottomBar_viewer">;
    readonly " $refType": "Header_viewer";
};
export type Header_viewer$data = Header_viewer;
export type Header_viewer$key = {
    readonly " $data"?: Header_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Header_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "hasSessionCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "zipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "relayIsClient",
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "Defer",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "userTracking_viewer"
            }
          ]
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "hasSessionCountryCode",
          "variableName": "hasSessionCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "TopBar_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BottomBar_viewer"
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isVip",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isVerifiedTrade",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "userTracking_user"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TopBar_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchRegionalInfo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": [
                (v2/*: any*/)
              ],
              "concreteType": "IncomeLevel",
              "kind": "LinkedField",
              "name": "incomeLevel",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "incomeBracket",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "incomePercentile",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = 'eff58ecba00305b1e2e1bee2c0a208db';
export default node;
